
import "@/assets/sass/template.scss";
import { defineComponent, onMounted, ref, reactive, computed, watch } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import TableTab from "@/components/kt-datatable/TableTab.vue";
import moment from "moment";
import PaginationUtill from "../util/PaginationUtill";
import store from "@/store";

export default defineComponent({
  name: "DataTable",

  components: {
    TableTab,
  },

  setup() {
    const AccountId = computed(() => store.getters.AccountId);
    const tableDatanew = ref([]);
    const graphHeader = ref([]);
    const colnames = ref();
    const graph = ref(false);
    const tablesumm = ref(false);
    const fromDate = ref(new Date());
    const toDate = ref(new Date());
    const loading = ref<boolean>(false);
    const series = reactive([{}]);

    interface TableHeader {
      name: string;
      key: string;
      sortable: boolean;
    }

    onMounted(() => {
      setCurrentPageBreadcrumbs("Last Bill Date - Water", ["NA"]);
      if(AccountId.value){
        getContent(AccountId.value)
      }    
      graph.value = true;
      tablesumm.value = false;
    });

    watch(AccountId, (newValue) => {
      if (newValue) {
        getContent(newValue);
      }
    });
    
    const OriginalTableHeaders = ref<Array<TableHeader>>();
    let tabheader: Array<TableHeader> = PaginationUtill.LastBillDateWater;

    OriginalTableHeaders.value = tabheader.map((a) => ({
      name: a.name,
      key: a.key,
      sortable: true,
    }));
    let fdate: any = new Date();
    fdate.setDate(fdate.getDate() - 365 * 2);
    let tdate: any = new Date();
    tdate.setDate(tdate.getDate());
    //let tdate: any = new Date().toLocaleDateString();

    async function getContent(id) {
      graph.value = true;
      loading.value = true;
      if(tablesumm.value){
        openAssetRemoval()
      }
      const accountInfo: any = {
        accountid: id,
        fdate: moment(fdate).format("YYYY-MM-DD 00:00:00"),
        tdate: moment(tdate).format("YYYY-MM-DD 00:00:00"),
      };

      ApiService.post("api/lastbilldate/water_lastbilldate", accountInfo)
        .then((resp) => {
          tableDatanew.value = resp.data.lbd_summaryWater.map((a) => a);
          colnames.value = tabheader.map((a) => a.key);
          graphHeader.value = resp.data.lbd_graphdataWater.map((a) => a.values);
          let dataval = resp.data.lbd_graphdataWater.map((a) => ({
            x: a.values,
            y: a.plotvalues,
          }));

          loading.value = false;
          series.splice(0);

          const datas = {
            data: dataval,
          };
          series.push(datas);
        })
        .catch((a) => {
          loading.value = false;
          console.log("Api Log Error", a);
        });
    }

    function openAssetGraph() {
      graph.value = true;
      tablesumm.value = false;
    }

    function openAssetRemoval() {
      graph.value = false;
      tablesumm.value = true;
    }

    const ebchartType = ref("bar");
    const waterchartType = ref("bar");
    const eboptions = {
      chartOptions: {
        chart: {
          type: "bar",

          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 1,
            columnWidth: 25 + "%",
          },
        },
        colors: [
          "#F3B415",
          "#F27036",
          "#663F59",
          "#6A6E94",
          "#4E88B4",
          "#00A7C6",
          "#18D8D8",
          "#A9D794",
          "#46AF78",
          "#A93F55",
          "#8C5E58",
          "#2176FF",
          "#33A1FD",
          "#7A918D",
          "#BAFF29",
        ],
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: "Number of Locations",
            style: {
              fontSize: "12px",
            },
          },
        },
        legend: {
          show: true,
          floating: false,
          fontSize: "20px",
        },
      },
    };

    function changeChartType(type) {
      ebchartType.value = type;
    }

    function changeWaterChartType(type) {
      waterchartType.value = type;
    }
    const createAccountInfo = (id) => {
      return {
        accountid: id,
        fdate: moment(fdate).format("YYYY-MM-DD 00:00:00"),
        tdate: moment(tdate).format("YYYY-MM-DD 00:00:00"),
      };
    };
    const downloadurl = "api/lastbilldate/downloadWaterFile";
    const downloadprops = createAccountInfo(AccountId);
    const pageheader = "Last Bill Date - Water";
    return {
      pageheader,
      OriginalTableHeaders,
      downloadurl,
      downloadprops,
      getContent,
      fromDate,
      toDate,
      openAssetGraph,
      openAssetRemoval,
      graph,
      tablesumm,
      eboptions,
      waterchartType,
      ebchartType,
      changeChartType,
      changeWaterChartType,
      loading,
      tabheader,
      tableDatanew,
      colnames,
      series,
      graphHeader,
    };
  },
});
